import { createApp } from 'vue'
import * as Sentry from "@sentry/vue";
import './style.css'
import App from './App.vue'

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://06bf7540172255a7130057c8436f8995@o4506813991092224.ingest.us.sentry.io/4510591907659776",
  sendDefaultPii: true,
  debug: false, // Production: disable debug logs
  tracesSampleRate: 0.5, // Sample 50% of transactions for performance
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions for replay
  replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors
});

app.mount('#app');
// Force Rebuild 01/17/2026 07:46:43
